
import $ from 'jquery'
export default {
    name: 'add-patient',
    components: {

    },
    props: {
        patientId: { type: [Number, String], default: 0 },
        dansModal: { type: Boolean, default: false }
    },
    data() {
        return {
            code: '',   
            loading: false, 
            btn_disable: false,

            patient: {
                country_suffix: '',
                patient_id: 0,
                matricule: "",
                civilite: "",
                nom: "",
                prenoms: "",
                email: "",
                date_naissance: "",
                lieu_de_naissance: "",
                sexe: "",
                profession: "",
                nationalite: "",
                numero_cni: "",
                numero_passeport: "",
                telephone: "",
                telephone_secondaire: "",
                personne_a_prevenir_nom: "",
                personne_a_prevenir_prenom: "",
                personne_a_prevenir_profession: "",
                personne_a_prevenir_quartier: "",
                personne_a_prevenir_phone: "",

                situation_matrimoniale: "",
                conjoint_nom: "",
                conjoint_prenoms: "",
                nombre_enfants: 0,

                type_patient: 'non_assure',
                le_malade: '',
                assur_principal_matricule: '',
                assur_principal_nom: '',
                assur_principal_prenom: '',
                assur_principal_sexe: '',
                assur_principal_phone: '',
                assur_principal_profession: '',
                assur_principal_quartier: '',
            },

            assur_selected: '',
            societe_selected: '',
            liste_societes: [],

            // Société à convention directe : travailleur ou membre de sa famille retrouvé (04/10/2026).
            membre_recherche: '',
            membres_trouves: [],
            membre_choisi: null,
            // Saisie manuelle sans le bouton : ajoutée à la convention à l'enregistrement (04/10/2026).
            ajouter_membre: true,
            // « + Ajouter ce nouveau travailleur » : travailleur, ou membre de sa famille, ajouté tout de suite (04/10/2026).
            nouveau_travailleur: null,
            // Assurance, convention ou société absente : créée depuis l'accueil (04/10/2026).
            creation: null,
            creation_societe: null,
            societe_a_choisir: null,
            recherche_membre_en_cours: false,
            recherche_membre_minuteur: null,

            // Tel input placeholder config
            options: { placeholder: "Ex. 90 00 00 00", maxlength: 11 },
            tel_is_required: false,
            country_code: '',
            malade_country_iso: this.default_country_code || '',
            assure_country_code: '',

            prefered_countries: [this.default_country_code],
            only_countries: ['tg', 'bj', 'ci', 'bf'],

            patient_id: 0,
            phone_is_exist: false,
            email_is_exist: false,
            is_error: false,
        }
    },
    watch: {
        code: function (val) {
            if (val) {
                // this.doToast2();
            }
        },

        assur_selected() {
            this.societe_selected = ''
            this.oublierMembre()
            this.choixAssurance()
        },

        societe_selected() {
            console.log(this.societe_selected);
        }

    },
    computed: {
        estConvention() {
            return !!this.assur_selected && this.assur_selected.type_tiers === 'convention'
        },
        libelleNomPatient() {
            return String(this.malade_country_iso || this.default_country_code || '').toLowerCase() === 'cd' ? 'Nom & Postnom' : 'Nom'
        },
        /**Formulaire data */
        sexes() {
            return this.$store.getters['sexes']
        },
        civilites() {
            return this.$store.getters['civilites']
        },
        situations() {
            return this.$store.getters['situationMatrimoniales'];
        },
        professions() {
            return this.$store.getters['professions'];
        },
        assurances() {
            return this.$store.getters['assurances'];
        },

        // patientInsert(){
        // 	return this.$store.getters['patient'];
        // },

        info_patient() {
            return this.$store.getters['info_patient'];
        },

        compagnie_assurances() {
            return this.$store.getters["compagnie_assurances"];
        },

        souscripteurs() {
            return this.$store.getters["souscripteurs"];
        }

    },
    mounted() {
        this.patient.country_suffix =this.default_country_code
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        this.loading = true
        this.$store.dispatch("getSexes").finally(() => {
            this.loading = false
        });

        this.$store.dispatch('getSituationsMatrimoniales');

        this.$store.dispatch('getCivilites')

        /**
         * Get Patient info
         */
        this.patient_id = this.dansModal ? Number(this.patientId) : Number(this.$route.params.patient_id)
        
        if (this.patient_id > 0) {
            this.$store.dispatch('getInfoPatient', this.patient_id).then(() => {
                console.log("info p: ",this.info_patient)
                this.fillInfoPatient()
            })
        }

        // Liste des assurances
        this.$store.dispatch("getAssurance")

    },
    methods: {
        fillInfoPatient() {
            const stripIndicatif = value => String(value || '').replace(/^\+\d+\s+/, '')
            const patient_tel = stripIndicatif(this.info_patient.patient_telephone_mobile)
            const assur_tel = stripIndicatif(this.info_patient.assure_telephone)

            this.patient = {
                country_suffix: this.default_country_code,
                patient_id: this.info_patient.patient_id,
                matricule: this.info_patient.patient_matricule,
                civilite: {
                    id: this.info_patient.patient_civilite_id,
                    description: this.info_patient.patient_civilite
                },
                nom: this.info_patient.patient_nom,
                prenoms: this.info_patient.patient_prenom,
                email: this.info_patient.patient_email,
                date_naissance: this.info_patient.patient_date_naissance,
                lieu_de_naissance: this.info_patient.patient_lieu_naissance,
                sexe: {
                    id: this.info_patient.patient_sexe_id,
                    specificatif: this.info_patient.patient_sexe
                },
                profession: this.info_patient.patient_profession,
                nationalite: this.info_patient.patient_nationalite,
                numero_cni: this.info_patient.patient_numero_cni,
                numero_passeport: this.info_patient.patient_numero_passeport,
                telephone: patient_tel,
                telephone_secondaire: this.info_patient.patient_telephone_secondaire || '',
                personne_a_prevenir_nom: this.info_patient.personne_a_prevenir_nom || '',
                personne_a_prevenir_prenom: this.info_patient.personne_a_prevenir_prenom || '',
                personne_a_prevenir_profession: this.info_patient.personne_a_prevenir_profession || '',
                personne_a_prevenir_quartier: this.info_patient.personne_a_prevenir_quartier || '',
                personne_a_prevenir_phone: this.info_patient.personne_a_prevenir_telephone || '',

                situation_matrimoniale: {
                    id: this.info_patient.patient_situation_matrimoniale_id,
                    descriptif: this.info_patient.patient_situation_matrimoniale
                },
                conjoint_nom: this.info_patient.patient_conjoint_nom,
                conjoint_prenoms: this.info_patient.patient_conjoint_prenoms,
                nombre_enfants: this.info_patient.patient_nombre_enfants,

                type_patient: (this.info_patient.est_assure == 0)?'non_assure':'assure',
                le_malade: this.info_patient.assure_est_luimeme,
                assur_principal_matricule: this.info_patient.assure_matricule,
                assur_principal_nom: this.info_patient.assure_nom,
                assur_principal_prenom: this.info_patient.assure_prenom,
                assur_principal_sexe: {
                    id: this.info_patient.assure_sexe_id,
                    specificatif: this.info_patient.assure_sexe
                },
                assur_principal_phone: assur_tel,
                assur_principal_profession: this.info_patient.assure_profession,
                assur_principal_quartier: this.info_patient.assure_quartier,
            }

            this.assur_selected = {
                id: this.info_patient.assurance_id,
                compagnie_assurance: this.info_patient.assurance
            }

            this.$nextTick(() => {
                this.societe_selected = {
                    souscripteur_id: this.info_patient.societe_id,
                    souscripteur: this.info_patient.societe
                }
            })
        },

        /**
         * Clear Error message
         */
        clearError() {
            console.log("typing..")
            this.tel_is_required = false
            this.phone_is_exist = false
            this.email_is_exist = false
            this.is_error = false
        },

        countryChanged(country) {
            this.country_code = '+' + country.dialCode
            this.malade_country_iso = country.iso2 || this.default_country_code
        }, 

        assureCountryChanged(country) {
            this.assure_country_code = '+' + country.dialCode
        },

        /**
         * Choix entre Patient assuré ou non
         */
        onAssurance() {
            if (this.patient.type_patient == 'assure') {
                // Le patient est assuré
                $('.est-assure').fadeIn(500)
            } else {
                // Le patient n'est pas assuré
                $('.est-assure').fadeOut(500)
            }
        },

        choixAssurance() {
            let assurance_id = this.assur_selected.id
            if (assurance_id > 0) {
                this.$store.dispatch("listeSouscripteur", assurance_id).then(() => {
                    this.liste_societes = this.souscripteurs
                    // Société créée depuis l'accueil : choisie d'office.
                    if (this.societe_a_choisir) {
                        const creee = this.liste_societes.find(s => Number(s.souscripteur_id || s.id) === Number(this.societe_a_choisir))
                        this.societe_a_choisir = null
                        if (creee) {
                            this.societe_selected = creee
                            return
                        }
                    }
                    // Une convention n'a qu'un contrat : il est choisi d'office.
                    if (this.estConvention && this.liste_societes.length === 1 && !this.societe_selected) this.societe_selected = this.liste_societes[0]
                })
            } else {
                this.liste_societes = []
            } 
        },

        /**
         * Dis si le malade est : 
         * Lui même ou son Conjoint ou encore son enfant
         */
         assureLuiMeme() {
            let cbox = document.getElementById('lui-meme');

            if (cbox.checked) {         //  Il s'agit de Lui-même
                this.patient.assur_principal_matricule = this.patient.matricule
                this.patient.assur_principal_nom = this.patient.nom
                this.patient.assur_principal_prenom = this.patient.prenoms
                this.patient.assur_principal_sexe = this.patient.sexe
                this.patient.assur_principal_phone = this.patient.telephone
            }else {
                this.patient.assur_principal_matricule = ''
                this.patient.assur_principal_nom = ''
                this.patient.assur_principal_prenom = ''
                this.patient.assur_principal_sexe = ''
                this.patient.assur_principal_phone = ''
            }
        },


        // Recherche du travailleur (matricule, nom, prénom) ; sa famille vient avec lui.
        rechercherMembre() {
            this.membre_choisi = null
            clearTimeout(this.recherche_membre_minuteur)
            const q = String(this.membre_recherche || '').trim()
            if (q.length < 2 || !this.estConvention) {
                this.membres_trouves = []
                return
            }
            this.recherche_membre_minuteur = setTimeout(() => this.chercherMembres(q), 300)
        },

        chercherMembres(q) {
            this.recherche_membre_en_cours = true
            return this.$store.dispatch('rechercherMembresConvention', { assurance_id: this.assur_selected.id, q }).then(reponse => {
                if (String(this.membre_recherche || '').trim() !== q) return
                this.membres_trouves = reponse && Array.isArray(reponse.membres) ? reponse.membres : []
            }).catch(() => {
                this.membres_trouves = []
            }).then(() => {
                this.recherche_membre_en_cours = false
            })
        },

        // Le membre choisi remplit l'assuré principal (son travailleur) et l'identité du patient.
        choisirMembre(membre) {
            if (!membre.couvert || (membre.patient_id && Number(membre.patient_id) !== Number(this.patient_id))) return
            this.membre_choisi = membre
            this.membres_trouves = []
            this.membre_recherche = (membre.nom + ' ' + (membre.prenoms || '')).trim()
            this.patient.assur_principal_matricule = membre.matricule_travailleur || membre.matricule || ''
            // Le malade garde son propre matricule (celui du travailleur s'il n'en a pas).
            this.patient.matricule = membre.matricule || ''
            this.patient.assur_principal_nom = membre.travailleur_nom || ''
            this.patient.assur_principal_prenom = membre.travailleur_prenoms || ''
            // Identité complète du travailleur (assuré principal) et du patient choisi.
            const sexe = id => (this.sexes || []).find(s => Number(s.id) === Number(id)) || ''
            const sansIndicatif = valeur => String(valeur || '').replace(/^\+\d+\s+/, '')
            this.patient.assur_principal_sexe = sexe(membre.travailleur_sexe_id)
            this.patient.assur_principal_phone = sansIndicatif(membre.travailleur_telephone)
            this.patient.assur_principal_profession = membre.travailleur_profession || ''
            this.patient.assur_principal_quartier = membre.travailleur_quartier || ''
            this.patient.le_malade = membre.lien === 'travailleur'
            this.patient.nom = membre.nom || ''
            this.patient.prenoms = membre.prenoms || ''
            if (membre.sexe_id) this.patient.sexe = sexe(membre.sexe_id)
            if (membre.date_naissance) this.patient.date_naissance = membre.date_naissance
            if (membre.telephone) this.patient.telephone = sansIndicatif(membre.telephone)
            if (membre.profession) this.patient.profession = membre.profession
        },

        oublierMembre() {
            this.nouveau_travailleur = null
            clearTimeout(this.recherche_membre_minuteur)
            this.membre_choisi = null
            this.membres_trouves = []
            this.membre_recherche = ''
        },

        // Travailleur absent : formulaire pré-rempli depuis la recherche (premier mot = nom, le reste = prénoms).
        ouvrirNouveauTravailleur() {
            const mots = String(this.membre_recherche || '').trim().split(/\s+/).filter(Boolean)
            const nom = mots.length ? mots[0].toUpperCase() : '', prenoms = mots.slice(1).join(' ')
            this.nouveau_travailleur = { matricule: '', nom, prenoms, sexe_id: null, date_naissance: '', telephone: '', indicatif: '',
                profession: '', quartier: '', erreur: '', en_cours: false,
                pour_famille: false, travailleur_existant: null, famille: this.familleVide(), depuis_recherche: { nom, prenoms } }
        },

        familleVide() {
            // nom_propose : nom du travailleur repris d'office pour un enfant, tant qu'il n'est pas modifié.
            return { lien: 'enfant', filiation: '', matricule: '', nom: '', prenoms: '', sexe_id: null, date_naissance: '', telephone: '', indicatif: '', profession: '', quartier: '', nom_propose: '' }
        },

        // Parent ou autre : la filiation précise de qui il s'agit (05/10/2026).
        lienAvecFiliation(lien) {
            return lien === 'parent' || lien === 'autre'
        },

        filiationsProposees(lien) {
            return lien === 'parent' ? ['Père', 'Mère']
                : ['Tante', 'Oncle', 'Cousin', 'Cousine', 'Neveu', 'Nièce', 'Frère', 'Sœur', 'Grand-père', 'Grand-mère', 'Beau-père', 'Belle-mère']
        },

        // Travailleur déjà enregistré (même déjà patient) : seul le membre de sa famille est ajouté.
        ouvrirFamilleDe(travailleur) {
            this.ouvrirNouveauTravailleur()
            Object.assign(this.nouveau_travailleur, { nom: '', prenoms: '', pour_famille: true, travailleur_existant: travailleur })
            this.synchroniserNomEnfant()
        },

        // Le nom tapé dans la recherche est celui du patient : il suit le patient d'un bloc à l'autre tant qu'il n'est pas modifié.
        choisirPatientFamille(oui) {
            const t = this.nouveau_travailleur
            if (!t || t.pour_famille === oui) return
            t.pour_famille = oui
            const [de, vers] = oui ? [t, t.famille] : [t.famille, t]
            if (!vers.nom && de.nom === t.depuis_recherche.nom && de.prenoms === t.depuis_recherche.prenoms) {
                Object.assign(vers, { nom: de.nom, prenoms: de.prenoms })
                Object.assign(de, { nom: '', prenoms: '' })
            }
            this.synchroniserNomEnfant()
        },

        // Enfant : le nom du travailleur s'affiche d'office et suit sa saisie ; une fois modifié, il n'est plus touché.
        // Autre lien (conjoint, autre) : le nom proposé est retiré.
        synchroniserNomEnfant() {
            const t = this.nouveau_travailleur
            if (!t || !t.pour_famille) return
            const f = t.famille
            const automatique = !f.nom || f.nom === f.nom_propose
            if (!automatique) return
            const nom = f.lien === 'enfant' ? String((t.travailleur_existant ? t.travailleur_existant.nom : t.nom) || '') : ''
            f.nom = nom
            f.nom_propose = nom
        },

        libelleAjoutMembre(t) {
            if (!t.pour_famille) return 'Ajouter le travailleur'
            return t.travailleur_existant ? 'Ajouter le membre de la famille' : 'Ajouter le travailleur et sa famille'
        },

        nomMembre(membre) {
            return ((membre && membre.nom) + ' ' + ((membre && membre.prenoms) || '')).trim()
        },

        paysNouveauTravailleur(pays) {
            if (this.nouveau_travailleur && pays && pays.dialCode) this.nouveau_travailleur.indicatif = '+' + pays.dialCode
        },

        paysNouveauFamille(pays) {
            if (this.nouveau_travailleur && pays && pays.dialCode) this.nouveau_travailleur.famille.indicatif = '+' + pays.dialCode
        },

        donneesMembre(m, user_id) {
            const numero = String(m.telephone || '').trim()
            return { matricule: m.matricule, nom: m.nom, prenoms: m.prenoms, sexe_id: m.sexe_id, date_naissance: m.date_naissance || null,
                telephone: numero ? ((numero.charAt(0) === '+' || !m.indicatif) ? numero : m.indicatif + ' ' + numero) : '',
                profession: m.profession, quartier: m.quartier, user_id }
        },

        // Ajouté tout de suite à la convention, puis choisi : la fiche se remplit. Patient de la famille : le travailleur
        // d'abord (s'il est nouveau), puis le membre de sa famille rattaché à lui ; c'est ce membre qui est choisi.
        ajouterNouveauTravailleur() {
            const t = this.nouveau_travailleur
            if (!t.travailleur_existant && !t.nom) { t.erreur = 'Indiquez le nom du travailleur.'; return }
            if (t.pour_famille && !t.famille.nom) { t.erreur = 'Indiquez le nom du membre de la famille.'; return }
            if (t.pour_famille && this.lienAvecFiliation(t.famille.lien) && !t.famille.filiation) {
                t.erreur = 'Précisez la filiation (' + (t.famille.lien === 'parent' ? 'père ou mère' : 'tante, oncle, cousin…') + ').'
                return
            }
            t.erreur = ''
            t.en_cours = true
            const user_id = this.utilisateurCreation()
            const assurance_id = this.assur_selected.id
            const travailleur = t.travailleur_existant ? Promise.resolve(t.travailleur_existant)
                : this.$store.dispatch('creerMembreConvention', { assurance_id, data: this.donneesMembre(t, user_id) })
            return travailleur.then(cree => {
                if (!t.pour_famille) return cree
                // Travailleur enregistré : un nouvel essai n'ajoute plus que le membre de sa famille.
                t.travailleur_existant = cree
                const data = Object.assign(this.donneesMembre(t.famille, user_id), { travailleur_id: cree.id, lien: t.famille.lien,
                    filiation: this.lienAvecFiliation(t.famille.lien) ? t.famille.filiation : null })
                return this.$store.dispatch('creerMembreConvention', { assurance_id, data })
            }).then(membre => {
                this.nouveau_travailleur = null
                this.choisirMembre(membre)
                const convention = this.assur_selected.compagnie_assurance || 'la convention'
                this.successMsg((t.pour_famille ? 'Membre de la famille ajouté à ' : 'Travailleur ajouté à ') + convention)
            }).catch(erreur => {
                t.erreur = this.messageCreation(erreur, t.travailleur_existant ? 'L’ajout du membre de la famille a échoué.' : 'L’ajout du travailleur a échoué.')
                t.en_cours = false
            })
        },

        ouvrirCreationAssurance() {
            this.creation_societe = null
            this.creation = { type_tiers: 'assurance', nom: '', souscripteur: '', taux: '', erreur: '', en_cours: false }
        },

        ouvrirCreationSociete() {
            this.creation = null
            this.creation_societe = { souscripteur: '', taux: '', erreur: '', en_cours: false }
        },

        tauxCreationValide(taux) {
            return /^\d+$/.test(String(taux).trim()) && Number(taux) <= 100
        },

        messageCreation(erreur, defaut) {
            const donnees = erreur && erreur.response ? erreur.response.data : null
            return (donnees && donnees.message) || defaut
        },

        utilisateurCreation() {
            const info = this.$store.getters['authInfo']
            return info ? info.id : 0
        },

        // Nouvelle compagnie (avec sa société souscriptrice) ou nouvelle société à convention ; ajoutée aux Paramètres.
        creerAssurance() {
            const c = this.creation
            if (!String(c.nom).trim()) { c.erreur = 'Indiquez le nom.'; return }
            if (c.type_tiers === 'assurance' && !String(c.souscripteur).trim()) { c.erreur = 'Indiquez la société souscriptrice.'; return }
            if (!this.tauxCreationValide(c.taux)) { c.erreur = 'Taux de prise en charge : nombre entier de 0 à 100 %.'; return }
            c.erreur = ''
            c.en_cours = true
            const donnees = { type_tiers: c.type_tiers, nom: String(c.nom).trim(), souscripteur: String(c.souscripteur).trim(), taux: Number(c.taux),
                user_id: this.utilisateurCreation() }
            return this.$store.dispatch('creerAssuranceRapide', donnees).then(reponse => {
                this.societe_a_choisir = reponse.souscripteur_id
                return Promise.resolve(this.$store.dispatch('getAssurance')).then(() => {
                    const liste = Array.isArray(this.compagnie_assurances) ? this.compagnie_assurances : []
                    const nouvelle = liste.find(a => Number(a.id) === Number(reponse.assurance.id)) || reponse.assurance
                    this.creation = null
                    this.assur_selected = nouvelle
                })
            }).catch(erreur => {
                c.erreur = this.messageCreation(erreur, 'La création a échoué.')
                c.en_cours = false
            })
        },

        // Nouvelle société souscriptrice de la compagnie choisie.
        creerSociete() {
            const c = this.creation_societe
            if (!String(c.souscripteur).trim()) { c.erreur = 'Indiquez le nom de la société.'; return }
            if (!this.tauxCreationValide(c.taux)) { c.erreur = 'Taux de prise en charge : nombre entier de 0 à 100 %.'; return }
            c.erreur = ''
            c.en_cours = true
            const data = { souscripteur: String(c.souscripteur).trim(), taux: Number(c.taux), user_id: this.utilisateurCreation() }
            return this.$store.dispatch('creerSouscripteurRapide', { assurance_id: this.assur_selected.id, data }).then(reponse => {
                this.societe_a_choisir = reponse.souscripteur_id
                this.creation_societe = null
                this.societe_selected = ''
                this.choixAssurance()
            }).catch(erreur => {
                c.erreur = this.messageCreation(erreur, 'La création a échoué.')
                c.en_cours = false
            })
        },

        libelleLienMembre(membre) {
            if (membre.lien === 'travailleur') return 'Travailleur'
            // « Parent (mère) », « Autre (tante) » : libellé préparé par la Clinique quand il existe.
            const lien = membre.lien_libelle || { conjoint: 'Conjoint(e)', enfant: 'Enfant', parent: 'Parent' }[membre.lien] || 'Ayant droit'
            return lien + ' de ' + (membre.travailleur || '')
        },

        savePatient: async function () {
            const isValid = await this.$refs.patient_form.validate();
            if (!isValid) {
                this.is_error = true
                return;
            }

            const numeroComplet = (indicatif, valeur) => {
                const numero = String(valeur || '').trim()
                return numero ? (numero.startsWith('+') ? numero : [indicatif, numero].filter(Boolean).join(' ')) : ''
            }
            let p_tel = numeroComplet(this.country_code, this.patient.telephone)
            let assur_tel = numeroComplet(this.assure_country_code, this.patient.assur_principal_phone)

            let new_patient = {}

            
            new_patient = {
                country_suffix: this.patient.country_suffix,
                patient_id: (this.patient_id)?this.patient_id:0,
                malade_matricule: this.patient.matricule,
                civilite: this.patient.civilite.id,
                nom: this.patient.nom,
                prenoms: this.patient.prenoms,
                email: this.patient.email,
                date_naissance: this.patient.date_naissance,
                lieu_de_naissance: this.patient.lieu_de_naissance,
                sexe: this.patient.sexe.id,
                profession: this.patient.profession,
                nationalite: this.patient.nationalite,
                numero_cni: this.patient.numero_cni,
                numero_passeport: this.patient.numero_passeport,
                telephone_mobile: p_tel,
                telephone_secondaire: this.patient.telephone_secondaire,
                personne_a_prevenir_nom: this.patient.personne_a_prevenir_nom,
                personne_a_prevenir_prenom: this.patient.personne_a_prevenir_prenom,
                personne_a_prevenir_profession: this.patient.personne_a_prevenir_profession,
                personne_a_prevenir_quartier: this.patient.personne_a_prevenir_quartier,
                personne_a_prevenir_phone: this.patient.personne_a_prevenir_phone,

                situation_matrimoniale: this.patient.situation_matrimoniale.id,
                conjoint_nom: this.patient.conjoint_nom,
                conjoint_prenoms: this.patient.conjoint_prenoms,
                nombre_enfants: this.patient.nombre_enfants,

                assur_selected: this.assur_selected.id,
                societe_selected: this.societe_selected.souscripteur_id || this.societe_selected.id,

                type_patient: this.patient.type_patient,
                le_malade: this.patient.le_malade,
                assur_principal_matricule: this.patient.assur_principal_matricule,
                assur_principal_nom: this.patient.assur_principal_nom,
                assur_principal_prenom: this.patient.assur_principal_prenom,
                assur_principal_sexe: this.patient.assur_principal_sexe && this.patient.assur_principal_sexe.id,
                assur_principal_phone: assur_tel,
                assur_principal_profession: this.patient.assur_principal_profession,
                assur_principal_quartier: this.patient.assur_principal_quartier,
                convention_membre_id: (this.estConvention && this.membre_choisi) ? this.membre_choisi.id : null,
                convention_ajouter_membre: (this.estConvention && !this.membre_choisi && this.ajouter_membre) ? 1 : 0
            },

            this.loading = true;

            console.log(new_patient);
            this.$store.dispatch('savePatient', new_patient).then(
                (response) => {
                    if (response < 0) {
                        if (response == -1) {
                            this.phone_is_exist = true
                        } else if (response == -2) {
                            this.email_is_exist = true
                        }
                    } else {
                        this.successMsg('Patient enregistré avec succès')
                        if (this.dansModal) this.$emit('saved')
                        else this.$router.push({ path: '/patients' });
                    }
                    this.loading = false;
                }
            ).catch(
                error => {
                    this.loading = false;
                    console.log(error);
                    // this.errorToast();
                }
            )
        },

        getSexes: function () {

            this.$store.dispatch("getSexes");
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        doToast2: function () {
            this.$toasted.show('Le compte du patient a été créé avec succès', {
                duration: 3000,
                action: [
                    {
                        text: 'X',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                ],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },
        errorToast: function () {
            this.$toasted.show('Veuillez fournir des informations valides', {
                duration: 3000,
                action: [
                    {
                        text: 'X',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                ],
                type: 'error',
                position: 'top-center'
            })
        }
    },
}
